import React from 'react';

import Link from 'next/link';

import IconProject from '@repo/ui-icons/IconProject';
import { CircleButton } from '@repo/ui-kit/components/core/Button';
import {
  H3,
  H4,
  H5,
  HeadingsProps,
} from '@repo/ui-kit/components/core/Typography';
import { themeClasses } from '@repo/ui-kit/css/utils';

import LandingImage from '../LandingImage';
import TextBlock from '../TextBlock/TextBlock';

import { ButtonWrapper, ImageWrapper, Tile } from './styles';
import { ImageTextTileProps, Size } from './types';

const titleComponentMap: Record<Size, React.FC<HeadingsProps>> = {
  s: H5,
  m: H4,
  l: H3,
};

export const ImageTextTile: React.FC<ImageTextTileProps> = ({
  title,
  description,
  image,
  url,
  backgroundColor,
  onClick,
  ...props
}) => {
  const variant = props.variant || 'default';
  const size = !props.size || variant === 'mockup' ? 's' : props.size;
  const Title = titleComponentMap[size];
  const card = (
    <Tile size={size}>
      <ImageWrapper backgroundColor={backgroundColor} variant={variant}>
        <LandingImage
          fill
          alt={image.alt ?? 'Media image'}
          provider={image.provider}
          src={image.url}
          style={{ objectFit: 'cover' }}
        />
        {variant === 'mockup' && (
          <ButtonWrapper className={themeClasses.light}>
            <CircleButton
              ariaLabel="Edit"
              icon={IconProject}
              name="editProjectButton"
              size="s"
              variant="secondary"
            />
          </ButtonWrapper>
        )}
      </ImageWrapper>
      {!!title && (
        <Title bold color="default">
          {title}
        </Title>
      )}
      {description && (
        <TextBlock
          paragraphType={size === 'l' ? 'p2' : 'p3'}
          text={description}
        />
      )}
    </Tile>
  );

  if (url) {
    return (
      <Link href={url} target="_blank" onClick={onClick}>
        {card}
      </Link>
    );
  } else {
    return card;
  }
};
